export const positionStyle: {[postion: string]: React.CSSProperties} = {
	tl: { top: 0, left: 0, paddingLeft: '15px', paddingTop: '15px' },
	tr: { top: 0, right: 0, paddingRight: '15px', paddingTop: '15px' },
	bl: { bottom: 0, left: 0, paddingLeft: '15px', paddingBottom: '15px' },
	br: { bottom: 0, right: 0, paddingRight: '15px', paddingBottom: '15px' }
};
